/**
 * utils/ajax-form.js — отправка форм через jquery-form (ajaxSubmit).
 * Только jQuery (глобально) + плагин jquery-form. Другие файлы из utils/ не требуются.
 * Опционально: window.showToast(message, type) для уведомлений.
 */
jQuery(document).ready(function () {
    if (!jQuery.fn.ajaxSubmit) {
        return;
    }

    jQuery(document).on("submit", ".form-ajax form", function (e) {
        e.preventDefault();
        ajaxSubmitForm(this, jQuery(this).closest(".form-ajax"));
        return false;
    });
});

// Основная функция отправки форм
window.ajaxSubmitForm = function (form, box, callback) {
    let formBox = jQuery(form);
    let submitButton = formBox.find('button[type="submit"]:visible');

    // Сохраняем оригинальное состояние кнопки
    let originalHtml = submitButton.html();
    let originalDisabled = submitButton.prop('disabled');

    let url = formBox.attr("action") || window.location.href;
    let options = {
        url: url,
        type: formBox.find("input[name='_method']").val() || "POST",
        dataType: "json",
        beforeSubmit: function () {
            jQuery(".is-invalid", box).removeClass("is-invalid");
            jQuery(".error-field-text", box).text("");
            jQuery(".load-box", box).show();
            jQuery(".alert", box).remove(); // Удаляем старые алерты внутри формы

            // Делаем кнопку неактивной и добавляем спиннер
            if (submitButton.length > 0) {
                submitButton.prop('disabled', true);
                submitButton.html('<i class="fas fa-spinner fa-spin text-warning me-2"></i> <span class="small">Обработка...</span>');
            }
        },
        complete: function () {
            jQuery(".load-box", box).hide();

            // Восстанавливаем кнопку
            if (submitButton.length > 0) {
                submitButton.prop('disabled', originalDisabled);
                submitButton.html(originalHtml);
            }
        },
        success: function (data) {
            // Триггер для кастомных действий
            formBox.trigger('ajax-success', [data]);

            // Замена контента формы на текст/HTML от сервера
            if (data.text !== undefined) {
                jQuery(box).addClass("content-body").html(data.text);
            }

            // Всплывающее уведомление
            if (data.message) {
                window.showToast(data.message, data.status || 'success');
            }

            // Скролл к указанной точке
            if (data.scroll !== undefined) {
                jQuery('body,html').animate({scrollTop: data.scroll}, 500);
            }

            // Редиректы и перезагрузка
            if (data.reload === true) {
                location.reload();
            }
            if (data.redirect !== undefined) {
                window.location.href = data.redirect;
            }

            // Закрытие модалки по ID
            if (data.close_modal) {
                let modal = bootstrap.Modal.getInstance(document.getElementById(data.close_modal));
                if (modal) {
                    modal.hide();
                }
            }

            // Колбек после успешной отправки
            if (typeof callback === 'function') {
                callback(data);
            }
        },
        error: function (data) {
            if (data.status === 422) {
                let errors = data.responseJSON.errors || data.responseJSON;
                for (let key in errors) {
                    let errorMessage = Array.isArray(errors[key]) ? errors[key][0] : errors[key];
                    jQuery(".error-field-text.error-" + key, box).text(errorMessage);
                    jQuery("*[name=" + key + "]", box).addClass("is-invalid");
                }
            } else {
                window.showToast('Системная ошибка. Попробуйте позже.', 'error');
            }
        }
    };
    // Контент TinyMCE-редакторов формы — в их textarea до сбора полей (функция есть на страницах с dashboard-бандлом).
    if (typeof window.syncTinymceEditorsIn === "function") {
        window.syncTinymceEditorsIn(formBox[0]);
    }

    formBox.ajaxSubmit(options);
}
